// Este archivo se genera automáticamente por features/routing/generate-route-registry.mjs.
//! No editar manualmente.

export const pathnames = {
  "/": "/",
  "/anomalies": "/anomalies",
  "/anomalies/[id]": "/anomalies/[id]",
  "/dashboard": "/dashboard",
  "/finish-registration": "/finish-registration",
  "/login": "/login",
  "/map": "/map",
  "/profile": "/profile",
  "/reports": "/reports",
  "/send-reset-email": "/send-reset-email",
  "/signal-history": "/signal-history",
  "/signal-history/[signalId]": "/signal-history/[signalId]",
  "/signal-history/recordings": "/signal-history/recordings",
  "/user-activity": "/user-activity",
  "/users": "/users",
} as const;
